import React from 'react';
import ReportFrame from '../ReportFrame';

export default class TpAssignmentDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          DynamicParams={['ClientId']}
          reportName='TPAssignment Details'
          reportParams={reportParams}
          id='tpassignmentdetailreport'
          name='tpassignmentdetailreport'
          title='Third-Party Assignment Detail Report'
        />
      </div>
    );
  }
}
